// shared/WhatsAppFloat.jsx
import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { brand, WA_HREF } from "./brand";

export function WhatsAppFloat() {
  return (
    <div className="fixed bottom-4 right-4 z-50 group">
      <a
        href={WA_HREF}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatear por WhatsApp"
        className="relative flex items-center justify-center rounded-full shadow-lg"
        style={{ width: 52, height: 52, background: brand.accentGreen }}
      >
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ background: brand.accentGreen }}
        />
        <WhatsAppIcon sx={{ fontSize: 26, color: "#fff", position: "relative" }} />
      </a>

      {/* Tooltip — desktop only */}
      <div className="pointer-events-none absolute right-[calc(100%+10px)] top-1/2 -translate-y-1/2 opacity-0 translate-x-2 transition-all md:group-hover:opacity-100 md:group-hover:translate-x-0">
        <div className="rounded-xl bg-slate-900/90 px-3 py-1.5 text-xs font-semibold text-white shadow whitespace-nowrap">
          Chatea con Ventas
        </div>
      </div>
    </div>
  );
}